var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDevJoomla(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#39B54A;}\r\n\t.st1{fill:#FBB03B;}\r\n\t.st2{fill:#EA2626;}\r\n\t.st3{fill:#46ADD1;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.4,17.5c-0.7,2.5-0.1,5.2,1.8,7l7.1,7.1l3.1-3.1l-7.1-7.1c-1.1-1.1-0.9-2.7,0.1-3.7c1-0.9,2.6-0.9,3.6,0 l0.2,0.2l3.1-3.1l-0.2-0.3c-1.8-1.8-4.2-2.4-6.6-1.9c-0.4-2.3-2.6-3.9-4.9-3.6C10.3,9.5,8.7,11.7,9,14 C9.4,15.8,10.7,17.1,12.4,17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M21.4,24.8l7.1-7.1c1-0.9,2.7-0.9,3.7,0.1c0.9,1,0.9,2.6,0,3.6L32,21.5l3.2,3.2l0.2-0.2 c1.8-1.8,2.5-4.5,1.8-6.9c2.3-0.3,4-2.5,3.7-4.8c-0.3-2.3-2.5-4-4.8-3.7c-1.9,0.2-3.4,1.8-3.7,3.7c-2.5-0.7-5.1,0-7,1.8l-7.1,7.1 L21.4,24.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M37.3,32.5c0.6-2.4-0.1-4.9-1.9-6.7l-7-7l-3.1,3.2l7.1,7.1c1,1,1,2.7,0,3.7c-1,1-2.7,1-3.7,0l0,0l-0.3-0.3 l-3.1,3.1l0.2,0.2c1.9,1.9,4.6,2.5,7.1,1.8c0.5,2.3,2.7,3.8,5,3.4c2.3-0.5,3.8-2.7,3.4-5C40.5,34,39.2,32.7,37.3,32.5L37.3,32.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M28.2,25.5L21,32.7c-1,0.9-2.7,0.8-3.7-0.2c-0.9-1.1-0.9-2.5,0-3.5l0.2-0.2l-3.1-3.2l-0.2,0.2 c-1.8,1.8-2.5,4.4-1.9,6.8C10,33.2,8.5,35.5,9,37.8c0.5,2.3,2.8,3.8,5.1,3.3c1.6-0.4,2.8-1.7,3.3-3.3c2.4,0.6,4.9-0.1,6.7-1.9 l7.1-7.1L28.2,25.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDevJoomla);
export default __webpack_public_path__ + "static/media/Icon-Dev-Joomla.165cad76ffca40c524b7e25362fd4a71.svg";
export { ForwardRef as ReactComponent };